import { regionApp, webappHost, webappHostMx } from '../utils/envs';

export const getRegion = () => {
  const regions = {
    'localhost:3000': regionApp,
    'mx-app.olist.com': 'mx',
    'app.olist.com': 'br',
    'app.staging.olist.io': 'br',
  };

  const region = window?.location?.host;

  const response = regions?.[region];

  return response ?? 'br';
};

export const appHosts = {
  br: webappHost,
  mx: webappHostMx,
};

export const getAppHostByRegion = () => {
  const region = getRegion();

  return appHosts[region];
};
